"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findBookingHorizonPolicy = findBookingHorizonPolicy;
exports.selectPoliciesForTable = selectPoliciesForTable;
exports.resolveHorizonDate = resolveHorizonDate;
exports.isDateBeyondHorizon = isDateBeyondHorizon;
const luxon_1 = require("luxon");
const TDR_1 = require("../types/TDR");
function findBookingHorizonPolicy(policies) {
    if (!(policies === null || policies === void 0 ? void 0 : policies.length)) {
        return undefined;
    }
    return policies.find(p => { var _a, _b; return (p === null || p === void 0 ? void 0 : p.type) === 'BookingHorizon' && ((_a = p === null || p === void 0 ? void 0 : p.cutoff) === null || _a === void 0 ? void 0 : _a.value) != null && ((_b = p === null || p === void 0 ? void 0 : p.cutoff) === null || _b === void 0 ? void 0 : _b.unit); });
}
function selectPoliciesForTable(policies, tableId) {
    if (!(policies === null || policies === void 0 ? void 0 : policies.length)) {
        return [];
    }
    const tableScoped = policies.filter(p => p.tableId === tableId);
    const restaurantScoped = policies.filter(p => !p.tableId);
    if (tableScoped.length === 0) {
        return restaurantScoped;
    }
    const tableHasBookingHorizon = tableScoped.some(p => { var _a, _b; return p.type === 'BookingHorizon' && ((_a = p.cutoff) === null || _a === void 0 ? void 0 : _a.value) != null && ((_b = p.cutoff) === null || _b === void 0 ? void 0 : _b.unit); });
    if (tableHasBookingHorizon) {
        return tableScoped;
    }
    return [...tableScoped, ...restaurantScoped];
}
function resolveHorizonDate(input) {
    var _a, _b;
    const { policies, restaurant } = input;
    const zone = restaurant.timezone || 'UTC';
    const now = ((_a = input.now) !== null && _a !== void 0 ? _a : luxon_1.DateTime.local()).setZone(zone);
    const policy = findBookingHorizonPolicy(policies);
    if (((_b = policy === null || policy === void 0 ? void 0 : policy.cutoff) === null || _b === void 0 ? void 0 : _b.value) != null && policy.cutoff.unit) {
        const date = now.plus({ [policy.cutoff.unit]: policy.cutoff.value });
        return { date, source: 'policy' };
    }
    // The admin stores this field as a string and clears it to '' (Number('') is 0); only a positive number counts.
    const bookableDays = Number(restaurant.bookableDaysInAdvance);
    if (restaurant.bookableDaysInAdvance != null && Number.isFinite(bookableDays) && bookableDays > 0) {
        const date = now.plus({ days: bookableDays });
        return { date, source: 'restaurant' };
    }
    const date = now.plus({ days: TDR_1.TDR.DEFAULT_BOOKABLE_DAYS });
    return { date, source: 'default' };
}
function isDateBeyondHorizon(target, input) {
    const { date: horizon, source } = resolveHorizonDate(input);
    // limitAvailability falsy disables the restaurant-level horizon, but never overrides a policy.
    if ((source === 'restaurant' || source === 'default')
        && !input.restaurant.limitAvailability) {
        return false;
    }
    const zone = input.restaurant.timezone || 'UTC';
    return target.setZone(zone).startOf('day') > horizon.startOf('day');
}
//# sourceMappingURL=horizon.js.map